<div class="picks-details-container">
    <div class="betslip-digital-pick__line-0 quickbet-grid-line-0">
        @switch (pickTypeFromPickList()) {
            @case (quickBetPickTypes.ComboPicks) {
                <span>{{ multiBetTitle() }}</span>
            }
            @case (quickBetPickTypes.BetBuilderPicks) {
                @if (isEpcotEnabled) {
                    <ms-sgp-badge></ms-sgp-badge>
                }
                <span>{{ buildABetTitle() }}</span>
            }
            @case (quickBetPickTypes.BetBuilderPlusPicks) {
                @if (isEpcotEnabled) {
                    <ms-sgp-plus-badge></ms-sgp-plus-badge>
                }
                <span>{{ multiBetTitle() }}</span>
            }
        }
    </div>

    @if (oddsViewModel$ | async; as oddsViewModel) {
        @switch (oddsViewModel.oddsState) {
            @case (pickOddsState.Locked) {
                <div [ngClass]="isEpcotEnabled ? 'theme-lock' : 'theme-locked-i ui-icon-size-lg'"></div>
            }
            @case (pickOddsState.Closed) {
                <div class="closed">{{ closedText }}</div>
            }
            @case (pickOddsState.Open) {
                <div class="quick-bet-odds-summary">
                    <span
                        [ngClass]="{ 'quick-bet-summary__original-odds--boosted': oddsViewModel.boostedOdds }"
                        [@oldOddsAnimation]="oddsViewModel.boostedOdds ? formattedOdds(oddsViewModel.totalOdds) : null"
                        >{{ formattedOdds(oddsViewModel.totalOdds) }}</span
                    >
                    @if (oddsViewModel.boostedOdds) {
                        <span class="quick-bet-summary__boosted-odds" [@newOddsAnimation]="formattedOdds(oddsViewModel.boostedOdds)">{{
                            formattedOdds(oddsViewModel.boostedOdds)
                        }}</span>
                    }
                </div>
            }
        }
    }
</div>
<div class="betslip-digital-pick__line-1 quickbet-grid-line-1" [msAutomation]="'betslip-digital-pick__market-name'">
    <ms-ellipsis
        bsNavigateToBetslip
        [ellipsisData]="optionNamesForMultiplePicks()"
        [contentDivider]="PICK_LIST_DIVIDER"
        [contentOverflowName]="sitecore.betslip.messages.Picks"
        [maxLineCount]="PICK_LIST_MAX_LINE_COUNT"></ms-ellipsis>
</div>
@if (showEachWayButton && !(freeBetToken$ | async)) {
    <button
        class="eachway-price-button"
        [class.selected]="isEachWaySelected || buttonDisable"
        [disabled]="buttonDisable"
        (click)="onEachWayClick($event)">
        {{ eachWayButtonTitle }}
    </button>
}
